import script from "./esInventory.vue?vue&type=script&setup=true&lang=js"
export * from "./esInventory.vue?vue&type=script&setup=true&lang=js"

import "./esInventory.vue?vue&type=style&index=0&id=4528dd00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4528dd00"]])

export default __exports__